import { render, staticRenderFns } from "./CourseIsFull.vue?vue&type=template&id=3f36121e&"
import script from "./CourseIsFull.vue?vue&type=script&lang=js&"
export * from "./CourseIsFull.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports